import { stringify } from "query-string"
import { farasod } from "./api"

const endpoint = "/order"

export const getPaidOrders = async queries => {
  const query = stringify(queries, { skipEmptyString: true, skipNull: true })

  const response = await farasod.get(`${endpoint}/kitchen?${query}`)

  return response.data
}

export const getOrderHistory = async queries => {
  const query = stringify(queries, { skipEmptyString: true, skipNull: true })

  const response = await farasod.get(`${endpoint}/history?${query}`)

  return response.data
}

export const assignRiderToOrder = async (orderId, data) => {
  const response = await farasod.patch(`${endpoint}/kitchen/${orderId}/assignRider`, data)

  return response.data
}

export const getOrders = async queries => {
  const query = stringify(queries,
    { skipEmptyString: true, skipNull: true }
  )

  const response = await farasod.get(`${endpoint}?${query}`)

  return response.data
}

export const getAllOrders = async queries => {
  const query = stringify(queries,
    { skipEmptyString: true, skipNull: true }
  )

  const response = await farasod.get(`${endpoint}/all?${query}`)

  return response.data
}

export const getKitchenOrders = async queries => {
  const query = stringify(queries, { skipEmptyString: true, skipNull: true })

  const response = await farasod.get(`${endpoint}/kitchen?${query}`)

  return response.data
}

export const changeOrderToDelivered = async (orderId) => {
  const response = await farasod.patch(`${endpoint}/kitchen/${orderId}/delivered`)

  return response.data
}

export const sendOrder = async data => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const getOrder = async orderId => {
  const response = await farasod.get(`${endpoint}/${orderId}`)

  return response.data
}

export const setOrderDelivered = async orderId => {
  const response = await farasod.patch(`${endpoint}?/kitchen/${orderId}/delivered`)

  return response.data
}

export const getStatisticReport = async (queries) => {
  const query = stringify(queries,
    { skipEmptyString: true, skipNull: true }
  )

  const response = await farasod.get(`${endpoint}/report/statistic?${query}`)

  return response.data
}

export const getFoodCostReport = async (queries) => {
  const query = stringify(queries,
    { skipEmptyString: true, skipNull: true }
  )

  const response = await farasod.get(`${endpoint}/report/food/cost?${query}`)

  return response.data
}

export const getShareholdersReport = async (queries) => {
  const query = stringify(queries,
    { skipEmptyString: true, skipNull: true }
  )

  const response = await farasod.get(`${endpoint}/report/shareholder?${query}`)

  return response.data
}

export const getReferralReport = async (queries) => {
  const query = stringify(queries,
    { skipEmptyString: true, skipNull: true }
  )

  const response = await farasod.get(`${endpoint}/report/referral?${query}`)

  return response.data
}

export const deleteOrder = async orderId => {
  const response = await farasod.delete(`${endpoint}?_id=${orderId}`)

  return response.data
}

export const editOrderAddress = async (orderId, data) => {
  const response = await farasod.patch(`${endpoint}/address/${orderId}`, data)

  return response.data
}

export const runOrderPrinter = async queries => {
  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await farasod.post(`${endpoint}/print/run?${query}`)

  return response.data
}

export const cancelOrderQuotation = async quotationId => {
  const response = await farasod.post(`${endpoint}/service/cancel/${quotationId}`)

  return response.data
}

export const cancelOrder = async (orderId, data) => {
  const response = await farasod.post(`${endpoint}/cancel/${orderId}`, data)

  return response.data
}

export const changeOrderStatusToDelivered = async (orderId) => {
  const response = await farasod.patch(`${endpoint}/status/${orderId}/delivered`)

  return response.data
}

export const getOrderByCode = async (orderCode) => {
  const response = await farasod.get(`${endpoint}/getByCode/${orderCode}`)

  return response.data
}

export const orderDispatched = async (orderId) => {
  const response = await farasod.post(`${endpoint}/dispatched/${orderId}`)

  return response.data
}

export const getNotViewedOrders = async (queries) => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}/unread/count?${query}`)

  return response.data
}

export const setOrdersAsViewed = async (data) => {
  const response = await farasod.post(`${endpoint}/unread/readall`, data)

  return response.data
}